import { MuiMessages, TranslationMuiMessages } from "../interfaces/muiMessages";

export const messages: TranslationMuiMessages = {
  [MuiMessages.autocompleteLoading]: "Carregando...",
  [MuiMessages.autocompleteNoOptions]: "Sem opções"
};
